import classNames from "classnames";
import classes from "./CardTag.module.less";

interface Props {
  className?: string;
  children?: string;
  rounded?: boolean;
}

export const CardTag = ({ className, rounded, children }: Props) => {
  const cls = classNames(classes.root, className, rounded && classes.rounded);
  return <div className={cls}>{children}</div>;
};
